import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-84370394"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "apply-form-container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "个人信息", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "学校信息", -1);
});

var _hoisted_4 = {
  class: "applyinfo-cont"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "报名成功", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sub-title"
  }, "请截屏保存考试账号和密码", -1);
});

var _hoisted_7 = {
  class: "applyinfo-item"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left"
  }, "账号： ", -1);
});

var _hoisted_9 = {
  class: "right"
};
var _hoisted_10 = {
  class: "applyinfo-item"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "left"
  }, "密码： ", -1);
});

var _hoisted_12 = {
  class: "right"
};
var _hoisted_13 = {
  class: "applyinfo-action"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" 去登录 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");

  var _component_a_row = _resolveComponent("a-row");

  var _component_a_divider = _resolveComponent("a-divider");

  var _component_a_button = _resolveComponent("a-button");

  var _component_a_form_item = _resolveComponent("a-form-item");

  var _component_a_form = _resolveComponent("a-form");

  var _component_a_modal = _resolveComponent("a-modal");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
    ref: "formRef",
    layout: "vertical",
    rules: _ctx.applyService.rules,
    model: _ctx.formState,
    "wrapper-col": {
      span: 12
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_col, null, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_a_row, null, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PersonalComList, function (item) {
            return _openBlock(), _createBlock(_resolveDynamicComponent(item), {
              key: item
            });
          }), 128))];
        }),
        _: 1
      }), _createVNode(_component_a_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_divider)];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _ctx.judeShowSchoolInfo ? (_openBlock(), _createBlock(_component_a_row, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_col, null, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_row, null, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SchoolComList, function (item) {
            return _openBlock(), _createBlock(_resolveDynamicComponent(item), {
              key: item
            });
          }), 128))];
        }),
        _: 1
      }), _createVNode(_component_a_row, {
        style: {
          "margin-top": "64px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_col, {
            span: 24
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_form_item, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_button, {
                    class: "btn-confirm",
                    type: "primary",
                    shape: "round",
                    size: "large",
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.userExamId ? '确认修改' : '确认报名'), 1)];
                    }),
                    _: 1
                  }, 8, ["onClick"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["rules", "model"]), _createVNode(_component_a_modal, {
    visible: _ctx.loginInfo.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.loginInfo.visible = $event;
    }),
    closable: false,
    "destroy-on-close": true,
    "mask-closable": false,
    width: 400,
    title: null,
    footer: null,
    keyboard: false,
    "body-style": {
      padding: '0 52px 34px 52px'
    },
    class: "applyinfo-dialog show-shadow",
    zIndex: 999
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.loginInfo.account), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.loginInfo.password), 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_button, {
        size: "large",
        maxlength: 6,
        class: "item-button",
        type: "primary",
        shape: "round",
        block: "",
        onClick: _ctx.applyToLogin
      }, {
        default: _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    _: 1
  }, 8, ["visible"])]);
}